import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const BottomMobileNav = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="mobile-bottom-nav d-lg-none d-print-none">
      <Link to="/dashboard" className={`nav-item-mobile ${isActive('/dashboard') ? 'active' : ''}`}>
        <i className="bi bi-grid-1x2-fill"></i>
        <span>होम</span>
        {isActive('/dashboard') && <span className="active-pill"></span>}
      </Link>

      <Link to="/entry/boat-expenses" className={`nav-item-mobile ${isActive('/entry/boat-expenses') ? 'active' : ''}`}>
        <i className="bi bi-water"></i>
        <span>पलट</span>
        {isActive('/entry/boat-expenses') && <span className="active-pill"></span>}
      </Link>

      <Link to="/entry/sales" className={`nav-item-mobile ${isActive('/entry/sales') ? 'active' : ''}`}>
        <i className="bi bi-receipt"></i>
        <span>व्यापारी बील</span>
        {isActive('/entry/sales') && <span className="active-pill"></span>}
      </Link>

      <Link to="/payments/customer-receipts" className={`nav-item-mobile ${location.pathname.startsWith('/payments') ? 'active' : ''}`}>
        <i className="bi bi-cash-stack"></i>
        <span>पेमेंट</span>
        {location.pathname.startsWith('/payments') && <span className="active-pill"></span>}
      </Link>

      <Link to="/reports/sales" className={`nav-item-mobile ${location.pathname.startsWith('/reports') ? 'active' : ''}`}>
        <i className="bi bi-bar-chart-fill"></i>
        <span>रिपोर्ट</span>
        {location.pathname.startsWith('/reports') && <span className="active-pill"></span>}
      </Link>
    </div>
  );
};

export default BottomMobileNav;
